import { api } from "./client";

export interface IntervalsStatus {
  connected: boolean;
  athlete_id: string | null;
  last_synced_at: string | null;
}

export async function getIntervalsStatus(signal?: AbortSignal): Promise<IntervalsStatus> {
  const { data } = await api.get<IntervalsStatus>("/integrations/intervals/status", { signal });
  return data;
}

export async function connectIntervals(
  athlete_id: string,
  api_key: string,
  signal?: AbortSignal,
): Promise<IntervalsStatus> {
  const { data } = await api.post<IntervalsStatus>("/integrations/intervals", {
    athlete_id,
    api_key,
  }, { signal });
  return data;
}

export async function disconnectIntervals(signal?: AbortSignal): Promise<void> {
  await api.delete("/integrations/intervals", { signal });
}

export interface SyncResult {
  new_workouts: number;
  updated: number;
  total: number;
  skipped?: number;
  restricted?: number;
  last_synced_at: string;
}

export async function syncIntervals(days = 30, signal?: AbortSignal): Promise<SyncResult> {
  const { data } = await api.post<SyncResult>(`/sync/intervals?days=${days}`, undefined, { signal });
  return data;
}
